var Backbone= require("backbone");
var MonitorsModel = require("models/monitors.model.ts");
require("backbonePaginator");
require("compat");

var PaginatedCollection = Backbone.PageableCollection.extend({
	mode: "server",
	model: MonitorsModel,
	// Initial pagination states
	state:
	{
		pageSize: 5,
		sortKey: "id",
		order: 1,
		firstPage: 0,
		page: 0
	},
	// Be sure to change this based on how your results are structured
	parse : function ( response )
	{
		if(!response.data && !response.content)
		{
			return response;
		}

		this.totalPages = response.data.pagesCount;
		this.state.lastPage = this.totalPages - 1;

        var objColl = [];
        var data = response.data.collection;
        for (var i=0; i<data.length; i++)
        {
            var obj = {
                queue: data[i].queue,
                queueStatistics: data[i].queueStatistics,
                nextTicketNumber: data[i].nextTicketNumber,
                countersInfo: data[i].countersInfo,
                nextCustomerCode: data[i].nextCustomerCode,
                currentPhone: data[i].currentTicketPhone,
                customerCode: data[i].customerCode,
                isPriorityTicket: data[i].isPriorityTicket,
                currentTicketDisplayNumber: data[i].currentTicketDisplayNumber
            };
            objColl.push(obj);
        }

		return objColl;
	},
	// Used by the template
	info : function ()
	{
		var info =
		{
			firstPage : this.state.firstPage,
			page : this.state.currentPage,
			lastPage : this.state.lastPage,
			perPage : this.state.pageSize
		};
		this.information = info;
		return info;
	}
});
module.exports = PaginatedCollection;